import type { HttpClient } from '@/lib/http/HttpClient';
import type { BaseResponse, Result } from '@/lib/http/HttpClient';

export interface InfluxConfigValues {
  host: string;
  port: number;
  user: string;
  password: string;
  database: string;
}

export interface InfluxConfigResponse extends BaseResponse {
  host?: string;
  port?: number;
  user?: string;
  password?: string;
  database?: string;
  configured?: false;
}

export class ConfigApiClient {
  private readonly http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getInfluxConfig(): Promise<Result<InfluxConfigResponse>> {
    return this.http.get<InfluxConfigResponse>('/api/config/influx');
  }

  saveInfluxConfig(values: InfluxConfigValues): Promise<Result<InfluxConfigResponse>> {
    return this.http.put<InfluxConfigResponse>('/api/config/influx', values);
  }
}
